<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title31"></a>
<div class="p-c-br"><span><em class="i">for Marilyn</em> <br/><em class="i">without whom, so much less</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466813120_ded01.vue?b27277cc